/*
 * Quick add to cart (product card hover button)
 * ---------------------------------------------
 * AJAX-adds the card's variant to the cart without leaving the page,
 * then notifies the theme (updateCart / cartChange) so the header cart
 * counter refreshes. Works with cart_type "page" (no drawer required).
 */
(function () {
  if (window.__quickAddInit) return;
  window.__quickAddInit = true;

  var RESET_DELAY = 1800;

  function addUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  function notifyCart() {
    ['updateCart', 'cartChange'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        composed: true,
        detail: { sectionId: null }
      }));
    });
  }

  function setLabel(btn, text) {
    var label = btn.querySelector('.\\#product-card-quick-add-text');
    if (label) label.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    // Keep the click from triggering the card's stretched-link.
    e.preventDefault();
    e.stopPropagation();

    if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = (btn.querySelector('.\\#product-card-quick-add-text') || {}).textContent || 'Add to cart';

    btn.classList.add('is-loading');
    btn.setAttribute('disabled', '');

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        btn.classList.remove('is-loading');
        if (!result.ok) {
          throw new Error((result.data && result.data.description) || 'Add to cart failed');
        }
        notifyCart();
        btn.classList.add('is-added');
        setLabel(btn, 'Added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.removeAttribute('disabled');
          setLabel(btn, original);
        }, RESET_DELAY);
      })
      .catch(function (err) {
        console.error('[quick-add]', err);
        btn.classList.remove('is-loading');
        setLabel(btn, 'Unavailable');
        setTimeout(function () {
          btn.removeAttribute('disabled');
          setLabel(btn, original);
        }, RESET_DELAY);
      });
  });
})();
